<!-- @format -->
<ng-container *ngIf="homrSketchfabModel && homrSketchfabId">
	<div class="sketchfab-embed-wrapper hmf-position-relative">
		<iframe
			class="sketchfab-embed-content hmf-position-absolute"
			[title]="homrSketchfabModel"
			width="100%"
			frameborder="0"
			allowfullscreen
			mozallowfullscreen="true"
			webkitallowfullscreen="true"
			allow="autoplay; fullscreen; xr-spatial-tracking"
			xr-spatial-tracking
			execution-while-out-of-viewport
			execution-while-not-rendered
			web-share
			[src]="homrSketchfabSrc">
		</iframe>
	</div>
</ng-container>
